import React from "react";


function AdminCenter() {
  return (
    ""
  );
}

export default AdminCenter;
